;(function (angular, _) {
  'use strict'

  angular
    .module('kilo.routes.entity.show', [])
    .config(RouteConfigurator)

  RouteConfigurator.$inject = ['$stateProvider']

  function RouteConfigurator ($stateProvider) {
    var showState = {
      name: 'entity.show',
      url: '/{id:[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}}',
      // Retire les watchers $rootScope des paginations résolues par cet état à sa sortie
      onExit: ['invoicePagination', 'quotePagination', 'creditNotePagination',
        function (invoicePagination, quotePagination, creditNotePagination) {
          [invoicePagination, quotePagination, creditNotePagination].forEach(function (p) { p.destroy() })
        }],
      resolve: {
        entity: ['$stateParams', 'EntityManager', function ($stateParams, EntityManager) {
          return EntityManager.findById($stateParams.id, EntityManager.query({
            populate: JSON.stringify([
              {
                path: 'defaultAddress'
              },
              {
                path: 'addresses'
              },
              {
                path: 'children'
              }
            ])
          }))
        }],
        invoicePagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('invoiceEntityList', {perPage: 5})
        } ],
        quotePagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('quoteEntityList', {perPage: 5})
        } ],
        creditNotePagination: [ 'PaginationModel', function (PaginationModel) {
          return PaginationModel.get('creditNoteEntityList', {perPage: 5})
        } ],
        generalPrefs: ['PreferencesService', function (PreferencesService) {
          return PreferencesService.getGeneralPrefs()
        }],
        path: ['EntityManager', 'entity', function (EntityManager, entity) {
          if (entity.parent) {
            return EntityManager.getParents(entity._id).then(function (data) {
              function sortByPath (availableElements, sortedArray) {
                if (!sortedArray || !sortedArray.length) {
                  var root = _.find(availableElements, function (element) {
                    return !element.parent
                  })
                  if (!root) {
                    return []
                  }
                  sortedArray = [root]
                }
                var lastOnPath = sortedArray[sortedArray.length - 1]
                var nextElement = _.find(availableElements, {parent: lastOnPath._id})
                if (!nextElement) {
                  return sortedArray
                }
                sortedArray.push(nextElement)
                return sortByPath(availableElements, sortedArray)
              }
              return sortByPath(data.data)
            })
          } else {
            return [entity]
          }
        }]
      },
      views: {
        'main@': {
          templateUrl: '/app/modules/entity/show/templates/entity-show.template.html',
          controller: 'EntityShowController',
          controllerAs: 'show'
        },
        'toolbar@': {
          templateUrl: '/app/modules/entity/show/templates/entity-show-toolbar.template.html',
          controller: 'EntityShowToolbarController',
          controllerAs: 'toolbar'
        }
      },
      ncyBreadcrumb: {
        label: '{{toolbar.title}}',
        parent: 'entity.list'
      }
    }

    $stateProvider
      .state(showState)
  }
})(window.angular, window._)
